import i18n from "i18next";
import Modal from "@/Components/Modals/Modal";
import ValidationErrors from "@/Components/ValidationErrors";
import {FormCheckbox, FormInput, FormInputCountrySelector, FormSelect} from "@/Components/Controls";
import {ButtonBorderless} from "@/Components/Buttons/ButtonBorderless";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";
import React, {useEffect, useState} from "react";
import {useForm} from "@inertiajs/inertia-react";

export default function EditOrgModal({props, state, dispatch}) {

    const {data, setData, post, processing, errors} = useForm({
        line_1: props.organization.address['line_1'],
        line_2: props.organization.address['line_2'],
        city: props.organization.address['city'],
        state: props.organization.address['state'],
        country_code: props.organization.address['country_code'] === 'US' ? 'us' : props.organization.address['country_code'], // Default to the United States
        postal_code: props.organization.address['postal_code'],
        // assign_to_parent_org: false,
        // select_parent_org: ''
    });

    const [stateOptions, setStateOptions] = useState();
    const [validationModal, setValidationModal] = useState(false);
    const [validationObjects, setValidationObjects] = useState([]);
    const [validationOptions, setValidationOptions] = useState([]);
    const [indexOfValidation, setIndexOfValidation] = useState();

    useEffect(() => {
        axios.get(route('organization.add-address.states'))
            .then(res => setStateOptions(res.data));
    }, [])

    function onChange(name, value) {
        setData(name, value);
    }

    useEffect(() => {
        setValidationOptions([]);

        if(typeof errors["suggestion_addresses"] !== 'undefined') {
            let suggestedAndEntered = [...JSON.parse(errors["suggestion_addresses"]), JSON.parse(errors["entered_address"])];
            let suggestedAndEnteredStrings = suggestedAndEntered.map(option =>
                `${option[Object.keys(option)[0]]}${option[Object.keys(option)[1]] ? ", " + option[Object.keys(option)[1]] : ""}
                        ${option[Object.keys(option)[2]] + ", " + option[Object.keys(option)[3]] + " " + option[Object.keys(option)[5]]}
                        ${option[Object.keys(option)[4]] === "us" ? "United States" : option[Object.keys(option)[4]]}`
            )
            setValidationObjects(suggestedAndEntered);
            setValidationOptions(suggestedAndEnteredStrings);
            setValidationModal(true);
        }
    }, [errors])

    useEffect(() => {
        if(typeof indexOfValidation === "number") {
            let autofill = validationObjects[indexOfValidation];
            setData({
                line_1: autofill["suggestion_line_1"] ? autofill["suggestion_line_1"] : autofill["entered_line_1"],
                line_2: autofill["suggestion_line_2"] ? autofill["suggestion_line_2"] : autofill["entered_line_2"] ? autofill["entered_line_2"] : "",
                city: autofill["suggestion_city"] ? autofill["suggestion_city"] : autofill["entered_city"],
                state: autofill["suggestion_state"] ? autofill["suggestion_state"] : autofill["entered_state"],
                country_code: autofill["suggestion_country"] ? autofill["suggestion_country"] === "United States" ? "us" : autofill["suggestion_country"] : autofill["entered_country"],
                postal_code: autofill["suggestion_postal_code"] ? autofill["suggestion_postal_code"] : autofill["entered_postal_code"]
            });
        }
    }, [indexOfValidation])

    function onChangeCountryCode(code) {
        onChange('country_code', code)
    }

    const hasDuplicates = (arr) => arr.length !== new Set(arr).size;

    const upperCaseInputs = (input) => {
        return input.toLowerCase()
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
    }

    const editOrgSave = (e) => {
        e.preventDefault();

        post(route('organization.add-address.store'));
    };

    return (
        <Modal isOpen={state.editOrgModal}
               title={i18n.t("admin-account-overview.edit-org-modal.edit-my-org")}
               id="unity"
               dialogClassName="edit-dialog"
               modalClassName="edit-modal"
               setIsOpen={() => dispatch({ type: "editOrgModal", payload: { editOrgModal: false}})}>
            <div className="modal-body">
                <form onSubmit={editOrgSave}>
                    {false && <ValidationErrors errors={errors}/>}
                    <div className="row">
                        <FormInput
                            error={errors["line_1"]}
                            name="line_1"
                            isFocused={true}
                            autoComplete="line_1"
                            value={data.line_1}
                            onChange={onChange}
                            label={i18n.t("add-address.line-1")}
                            className="col-12"
                            dataQa="add-address-line-1"
                        />
                    </div>

                    <div className="row">
                        <FormInput
                            error={errors["line_2"]}
                            name="line_2"
                            autoComplete="line_2"
                            value={data.line_2}
                            onChange={onChange}
                            label={i18n.t("add-address.line-2")}
                            className="col-12"
                            dataQa="add-address-line-2"
                        />
                    </div>

                    <div className="row">
                        <FormInput
                            error={errors["city"]}
                            name="city"
                            autoComplete="city"
                            value={data.city}
                            onChange={onChange}
                            label={i18n.t("add-address.city")}
                            className="col-12"
                            dataQa="add-address-city"
                        />
                    </div>

                    <div className="row">
                        { data.country_code === "us" ?
                            <FormSelect
                                error={errors["state"]}
                                name="state"
                                autoComplete="state"
                                value={data.state}
                                onChange={onChange}
                                isSearchable={true}
                                label={i18n.t("add-address.state")}
                                className="col-12"
                                dataQa="add-address-state"
                                options={stateOptions}
                            /> :
                            <FormInput
                                error={errors["state"]}
                                name="state"
                                autoComplete="state"
                                value={data.state}
                                onChange={onChange}
                                label={i18n.t("add-address.province")}
                                className="col-12"
                                dataQa="add-address-state"
                            />
                        }
                    </div>

                    <div className="row country-row">
                        <FormInputCountrySelector
                            error={errors["country_code"]}
                            name="country_code"
                            value={data.country_code}
                            onChange={onChangeCountryCode}
                            label={i18n.t("add-address.country-code")}
                            placeholder={i18n.t("add-address.country-code")}
                            className="col-12"
                        ></FormInputCountrySelector>
                    </div>

                    <div className="row">
                        <FormInput
                            error={errors["postal_code"]}
                            name="postal_code"
                            autoComplete="zip"
                            value={data.postal_code}
                            onChange={onChange}
                            label={i18n.t("add-address.zip")}
                            className="col-12"
                            dataQa="add-address-zip"
                        />
                    </div>

                    {/* Commented out due to not having parent org functionality yet */}
                    {/*<div className="row">*/}
                    {/*    <FormCheckbox*/}
                    {/*        name="assign_to_parent_org"*/}
                    {/*        label={i18n.t("admin-account-overview.edit-org-modal.assign-to-parent-org")}*/}
                    {/*        onChange={onChange}*/}
                    {/*        value={data.assign_to_parent_org}*/}
                    {/*        className="col-12"*/}
                    {/*        dataQa="assign-to-parent-org"/>*/}
                    {/*</div>*/}

                    {/*<div className="row">*/}
                    {/*    <FormSelect*/}
                    {/*        error={errors["select_parent_org"]}*/}
                    {/*        name="select_parent_org"*/}
                    {/*        autoComplete="select_parent_org"*/}
                    {/*        value={data.select_parent_org}*/}
                    {/*        onChange={onChange}*/}
                    {/*        isSearchable={true}*/}
                    {/*        label={i18n.t("admin-account-overview.edit-org-modal.select-parent-org")}*/}
                    {/*        className="col-12"*/}
                    {/*        dataQa="select-parent-org"*/}
                    {/*        options={[]}*/}
                    {/*    />*/}
                    {/*</div>*/}

                    <div className="modal-actions">
                        <ButtonBorderless className="modal-cancel" onClick={() => dispatch({ type: "editOrgModal", payload: { editOrgModal: false}})}>
                            {i18n.t("admin-account-overview.cancel")}
                        </ButtonBorderless>
                        <ButtonPrimary type="submit" processing={processing} disabled={processing} onClick={() => {
                            setData(prevState => ({
                                line_1: upperCaseInputs(prevState.line_1),
                                line_2: data.line_2 ? upperCaseInputs(prevState.line_2) : data.line_2,
                                city: upperCaseInputs(prevState.city),
                                state: prevState.country_code === "us" ? prevState.state : upperCaseInputs(prevState.state),
                                country_code: prevState.country_code,
                                postal_code: prevState.postal_code
                            }));
                        }}>
                            {i18n.t("admin-account-overview.save")}
                        </ButtonPrimary>
                    </div>
                </form>
            </div>
        </Modal>
    )
}
